export class BadgeDetailsModel{
  id: string = "xxx";
  badgeID: string = "xx-xx-xx-xx";
  badgeName: string = "xxxx xxxx xxxx xxxx";
  badgeIconImage: string = "xxx";
  earnedDate: string = "xxx";
  level: number = 0;
}
